import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ 
  className = "", 
  size = "medium", 
  linkTo = "/dashboard", 
  showAsLink = true 
}) => {
  const sizeClasses = {
    small: "h-6 sm:h-8",
    medium: "h-8 sm:h-10", 
    large: "h-12 sm:h-16",
    xlarge: "h-16 sm:h-20"
  };

  const logoElement = (
    <img 
      src="/logo.svg" 
      alt="FormCare" 
      className={`w-auto ${sizeClasses[size]} ${className}`}
      width="214"
      height="67"
    />
  );

  if (!showAsLink) {
    return (
      <div className="inline-flex items-center">
        {logoElement}
      </div>
    );
  }

  return (
    <Link 
      to={linkTo} 
      className="inline-flex items-center hover:opacity-80 transition-opacity"
    >
      {logoElement}
    </Link>
  );
};

export default Logo; 